import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import { Header2 } from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import { API_URL, API_URL_SAVE_ANSWER,API_URL_PHOTO, PENGAWAS_API_URL, SECRET_SESSION } from "../constants.js";
import CountdownTimer from "./shares/CountdownTimer.js";
import { FaArrowRight, FaArrowLeft, FaCheck } from "react-icons/fa";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import { decrypt, decrypt_res, encrypt_res } from "./shares/GlobalFunction.jsx";
import AlertModal from "./shares/AlertModal.js";
import PauseModal from "./shares/PauseModal.js";
import Toggle from "./shares/ToggleSwitch.js";
import moment from "moment-timezone";
import Loader from "./shares/Loader.jsx";
import AlertProgres from "./shares/AlertProgres.js";
import axiosInstance from "./shares/axiosConfig.js";
import AudioQuestion from './shares/AudioQuestion';
import MessageModal from "./shares/MessageModal.js";
import { PiCaretLeftBold, PiGridNine, PiMagnifyingGlassMinus, PiMagnifyingGlassPlus,PiClock, PiCaretRightBold } from "react-icons/pi";
import {
  ACCESS_STATUS_CONFIG,
  checkAccessStatus,
  checkPesanPengawas,
  registerFCMToken,
  initializeNotificationSystem,
} from '../utils/testNotificationUtils';
import Loading from "./shares/Loading.jsx";
import InfoStatusJawab from "./shares/InfoStatusJawab.jsx";

function ProsesTest2() {

  const [isLoading, setIsLoading] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);
  const [isMessageModalOpen, setModalMessageOpen] = useState(false);
  const [pesanPengawas, setPesanPengawas] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  // const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const navigate = useNavigate();
  const timerRef = useRef();
  const [starTimer, setStarTimer] = useState("start");
  // const [maxIndex, setMaxIndex] = useState(0);

  const [isVisibleNavigasiSoal, setIsVisibleNavigasiSoal] = useState(true);

  // Add a new ref to store the access status check interval
  const accessStatusCheckIntervalRef = useRef([]);

  // add a new ref to store the notification check interval
  const notificationCheckIntervalRef = useRef([]);

  const intervalRef = useRef([]);

  // Add new state to track access status
  const [accessStatus, setAccessStatus] = useState(null);
  const [isBtnNavigasiEnabled, setIsBtnNavigasiEnabled] =  React.useState(false);

  // Add state for FCM setup
  const [fcmInitialized, setFcmInitialized] = useState(false);

  // variable to handle stopModal
  const [catatanPengawas, setCatatan] = useState('');

  // initialize userData at the top
  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    navigate("/login");
  }
  let kamera = localStorage.getItem("kamera");
  
  // Initialize id_ujian at the top
  let id_ujian = localStorage.getItem("id_ujian");

  // Function to clear all access status check timers
  const clearAccessStatusCheckTimers = () => {
    accessStatusCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    accessStatusCheckIntervalRef.current = [];
  };

  // function to clear all notification check timers
  const clearNotificationCheckTimers = () => {
    notificationCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    notificationCheckIntervalRef.current = [];
  }

  // Function to clear all timers
  const clearAllTimers = () => {
    // Clear general intervals
    intervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    intervalRef.current = [];
    
    // Clear access status check timers
    clearAccessStatusCheckTimers();
    
    // Clear notification check timers
    clearNotificationCheckTimers();
  };

  React.useEffect(() => {
    // Notify Android that the candidate has entered an active exam session.
    // Android uses this to activate strict background detection (FR-024, FR-025).
    window.AndroidBridge?.notifyExamStarted();

    initializeNotificationSystem(
      userData,
      id_ujian,
      accessStatusCheckIntervalRef,
      notificationCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      setFcmInitialized,
      setAlertTimeOutOpen
    );

    // Cleanup on component unmount
    return () => {
      clearAccessStatusCheckTimers(accessStatusCheckIntervalRef);
      clearNotificationCheckTimers(notificationCheckIntervalRef);
    };
  }, [userData.id_projek, userData.id_siswa, userData.pengawas, id_ujian, navigate]);

  React.useEffect(() => {
    if (effectsCompleted >= 3) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  const [pesan, setPesan] = useState("Tes Anda dihentikan sementara. Silahkan hubungi pengawas.");
  
    // React.useEffect(() => {
    //   const userId = userData.nopes;
    //   const eventSource = new EventSource(API_URL+`/events/${userId}`);
  
    
    //   eventSource.onmessage = (event) => {
    //     const data = JSON.parse(event.data);
    //     // console.log("Pesan dari server:", data.message);
    
    //     if (data.message === 'LOGOUT') {
    //       // localStorage.setItem("countdown", "logout");
    //       setStarTimer("pause");
    //       timerRef.current.pause(); // Pause the timer
    //       // setPesan(data.detail);
    //       setStopModalOpen(true);
          
    //       //navigate("/peserta/logout");
    //     }
    
    //     if (data.message === "PAUSE_UJIAN") {
    //     //   // localStorage.setItem("countdown", "pause");
    //       setStarTimer("pause");
    //     //   timerRef.current.pause(); // Pause the timer
    //     //   // setPesan(data.detail);
    //     //   setPauseModalOpen(true);
    //     }
  
    //     if (data.message === "START_UJIAN") {
    //       // localStorage.setItem("countdown", "start");
    //       setPauseModalOpen(false);
    //       setStopModalOpen(false);
    //       timerRef.current.start(); // Start the timer
    //       setStarTimer("start");
    //     }
    //   };
    
    //   return () => {
    //     eventSource.close();
    //   };
    // }, [userData.nopes, navigate, timerRef]);
  
    let id_test = localStorage.getItem("mulai_ujian");
    if (id_test) {
      id_test = JSON.parse(decrypt(id_test));
    } else {
      navigate("/login");
    }


    React.useEffect(() => {
          const statusTimeOut = localStorage.getItem('statusTimeOut_'+userData.id_siswa+'_'+id_test);
          setAlertTimeOutOpen(statusTimeOut === "true" || statusTimeOut === true);
      }, [id_test]);
  


  const [post, setPost] = React.useState(null);
  const [dataProjek, setDataProjek] = useState(null);

  React.useEffect(() => {
    axios.post(API_URL + "/login/info").then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
    });
    setEffectsCompleted((prev) => prev + 1);
    let accessToken = localStorage.getItem("token");
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, {headers: {Authorization: `Bearer ${accessToken}`}})
    .then((response) => {
      setDataProjek(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    })
  }, []);


  const [Subtest, setSubtest] = React.useState(null);
  const [DaftarSoal, setDaftarSoal] = React.useState(null);
  let initialStatus = [].fill("");
  const [statusJawaban, setStatusJawaban] = useState(initialStatus);
  const [idSoal, setIdSoal] = useState(initialStatus);
  const [waktuMengerjakan, setWaktuMengerjakan] = useState(initialStatus);
  const [statusSave, setStatusSave] = useState(initialStatus);

  let tPertanyaan = localStorage.getItem("tampilPertanyaan") || true;
  let tJawaban = localStorage.getItem("tampilJawaban") || false;
  let sAktif = parseInt(localStorage.getItem("soalAktif")) || 0;
  let cBack = localStorage.getItem("canBack") || false;

  const [tampilPertanyaan, setTampilPertanyaan] = useState(tPertanyaan);
  const [tampilJawaban, setTampilJawaban] = useState(tJawaban);
  const [soalAktif, setSoalAktif] = useState(sAktif);
  const [canBack, setCanBack] = useState(cBack);
  const [autoNext] = useState(false);
  // setCanBack(cBack);


  React.useEffect(() => {
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/get_soal_aktif", {data: payload}).then((response) => {
      
      if (response.data.status === 200) {
        setSoalAktif(parseInt(response.data.data.soal_aktif));
        localStorage.setItem("soalAktif", parseInt(response.data.data.soal_aktif));

        if (response.data.data.value !== '') setShowNext(true);
        setActiveTabIndex(parseInt(response.data.data.soal_aktif));
        setNoSoal(parseInt(response.data.data.soal_aktif) + 1);

      } else {
        setSoalAktif(sAktif);
        setActiveTabIndex(sAktif);
        setNoSoal(sAktif + 1);
      }

      
    });
  }, []);

  React.useEffect(() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    axiosInstance
      .post(API_URL + "/peserta/subtest", {
        data: encryptedPayload,
      })
      .then((response) => {
        // console.log(response);
        // alert(JSON.stringify(response.data.data[0]));
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );

        let detailTes = decResponse[0];

        // Check for access denied response
        if (detailTes.error_message) {
          alert(detailTes.error_message);
          navigate("/peserta/logout");
          return;
        }
        if (detailTes.tipe_tes === 1) {
          navigate("/peserta/start_test");
        }

        if (parseInt(response.data.data[0].jenis_tes) === 20) {
          navigate("/peserta/start_test_kraeplin");
        }

        if (detailTes.akses_ujian) {
          if (detailTes.akses_ujian === "pause") {
            // setStarTimer("pause");
            // setPauseModalOpen(true);
          } else if (detailTes.akses_ujian === "logout") {
            setStarTimer("pause");
            setStopModalOpen(true);
            // navigate("/peserta/logout");
          }
        }

        setSubtest(detailTes);

        const payload = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_projek_ujian: id_test,
          id_naskah: detailTes.id_naskah,
          kode_paket_soal: detailTes.id_paket_soal,
          id_ujian: id_ujian,
          timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );

        axiosInstance
          .post(API_URL + "/peserta/daftarsoal", {
            data: encryptedPayload,
          })
          .then((response) => {
            response.data.data = JSON.parse(
              decrypt_res(response.data.data, SECRET_SESSION)
            );

            response.data.answer = JSON.parse(
              decrypt_res(response.data.answer, SECRET_SESSION)
            );

            setDaftarSoal(response.data.data);
            let newStatusJawaban = [];
            let newIdSoal = [];
            let newStatusSave = [];
            let newWaktuMengerjakan = [];
            let newJenisSoal = [];

            let localStatusJawaban = localStorage.getItem("statusJawaban");
            let localStatusSave = localStorage.getItem("statusSave");
            let localIdSoal = localStorage.getItem("idSoal");
            let localWaktuMengerjakan =
              localStorage.getItem("waktuMengerjakan");

            if (localWaktuMengerjakan) {
              newWaktuMengerjakan = JSON.parse(
                localStorage.getItem("waktuMengerjakan")
              );
            } else {
              if (response.data.redis===1) {
                newWaktuMengerjakan = response.data.answer.waktuMengerjakan.split(",");

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              } else {
                response.data.answer.map((item) => {
                  //moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
                  newWaktuMengerjakan[item.no_soal - 1] = moment(
                    item.waktu_mengerjakan
                  ).format("YYYY-MM-DD HH:mm:ss");
                  return item;
                });

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              }
            }

            // if (localIdSoal) {
            //   newIdSoal = JSON.parse(localStorage.getItem("idSoal"));
            // } else {
            //   response.data.answer.map((item) => {
            //     newIdSoal[item.no_soal - 1] = item.id_soal;
            //     return item;
            //   });

            //   localStorage.setItem("idSoal", JSON.stringify(newIdSoal));
            // }

            response.data.data.listSoal.map((item) => {
              newIdSoal[item.no_soal - 1] = parseInt(item.id_soal);
              return item;
            });
            localStorage.setItem("idSoal", JSON.stringify(newIdSoal));

            response.data.data.listSoal.map((item) => {
              newJenisSoal[item.no_soal - 1] = parseInt(item.jenis_soal);
              return item;
            });
            localStorage.setItem("jenisSoal", JSON.stringify(newJenisSoal));

            if (localStatusSave) {
              newStatusSave = JSON.parse(localStorage.getItem("statusSave"));
            }

            if (localStatusJawaban) {
              newStatusJawaban = JSON.parse(
                localStorage.getItem("statusJawaban")
              );
            } else {
              if (response.data.redis===1) {
                newStatusJawaban = response.data.answer.statusJawaban.split(",");

                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
              } else {
                response.data.answer.map((item) => {
                  if (parseInt(item.jenis_soal) === 1)
                    newStatusJawaban[item.no_soal - 1] = item.jawaban_pilihan;
                  else newStatusJawaban[item.no_soal - 1] = item.jawaban_essai;

                  // newIdSoal[item.no_soal - 1] = item.id_soal;
                  // newWaktuMengerjakan[item.no_soal - 1] = item.waktu_mengerjakan;

                  return item;
                });

                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
              }
            }

            if (newIdSoal) setIdSoal(newIdSoal);
            if (newWaktuMengerjakan) setWaktuMengerjakan(newWaktuMengerjakan);
            if (newStatusSave) setStatusSave(newStatusSave);

            if (newStatusJawaban) {
              setStatusJawaban(newStatusJawaban);
              const initialSelectedValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (newStatusJawaban[i] !== "") {
                  initialSelectedValues["jawaban" + i] = newStatusJawaban[i];
                }
              }
              setSelectedValues(initialSelectedValues);

              const initialSelectedCheckBoxValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  initialSelectedCheckBoxValues["jawaban" + i] = new Set(
                    newStatusJawaban[i].split(";")
                  );
                }
              }
              setSelectedCheckBoxValues(initialSelectedCheckBoxValues);

              const initialSelected3Values = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  let tmpJawaban = newStatusJawaban[i].split(";");
                  for (let j = 0; j < tmpJawaban.length; j++) {
                    let tmpOpsi = tmpJawaban[j].split("|");
                    initialSelected3Values[tmpOpsi[0]] = parseInt(tmpOpsi[1]);
                  }
                }
              }
              setSelected3Values(initialSelected3Values);
            }
            setEffectsCompleted((prev) => prev + 1);
          });
        setEffectsCompleted((prev) => prev + 1);
      });
  }, [id_test, id_ujian, navigate, userData.id_projek, userData.id_siswa]);

  const webcamRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);

  // const capture = () => {
  //   //get photo best resolution webcam
  //   if (webcamRef.current) {
  //     const imageSrc = webcamRef.current.getScreenshot({
  //       width: 640,
  //       height: 480,
  //     });
  //     // setCapturedImage(imageSrc);
  //     //axios kirim gambar ke server
  //     // alert(imageSrc);

  //     axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
  //       id_projek: userData.id_projek,
  //       id_siswa: userData.id_siswa,
  //       id_ujian: id_ujian,
  //       nopes: userData.nopes,
  //       image: imageSrc,
  //     });
  //   } else {
  //     console.error("Webcam reference is null");
  //   }
  // };

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [noSoal, setNoSoal] = useState(1);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    setNoSoal(index + 1);
    setCountdown(5);
    setShowOption(false);
    setTampilJawaban(false);
    setTampilPertanyaan(true);
    setShowNext(false);
    localStorage.setItem("tampilPertanyaan", true);
    localStorage.setItem("tampilJawaban", false);
    localStorage.setItem("soalAktif", index);

    //set soal aktif ke redis
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
      soal_aktif : index
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_soal_aktif", {data: payload});
  };

  const handleNextTab = () => {
    if (activeTabIndex < DaftarSoal.listSoal.length - 1) {
      let nextIndex = activeTabIndex + 1;

      if (canBack) {
        let emptyIndex = statusJawaban.findIndex(
          (item) => item === "" || item === null || item === undefined
        );
        if (emptyIndex !== -1) {
          handleTabChange(emptyIndex);
        } else {
          let index = statusJawaban.length - 1;
          setActiveTabIndex(index);
          setNoSoal(index + 1);

          if (statusJawaban[index] !== "") {
            setTampilJawaban(true);
            setShowNext(true);
          }
          //handleTabChange(statusJawaban.length - 1);
        }
      } else {
        handleTabChange(nextIndex);
      }
    }
  };

  const handlePreviousTab = () => {
    let nextIndex = activeTabIndex - 1;
    setActiveTabIndex(nextIndex);
    setNoSoal(nextIndex + 1);
  };

  const setTab = (index) => {
    if (canClikTab) {
      setActiveTabIndex(index);
      setNoSoal(index + 1);
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const [fontSize, setFontSize] = useState(18); // Initial font size in pixels

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 2); // Increase font size by 2px
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 10)); // Decrease font size by 2px but not below 10px
  };

  const handleFinishTest = () => {
    const hasEmpty = statusJawaban.some(
      (item) => item === "" || item === null || item === undefined
    );

    let localJawban = localStorage.getItem("statusJawaban");

    let countEmpty = 0;
    if (localJawban) {
      localJawban = localJawban.split(",");
      countEmpty = localJawban.filter(
        (item) => item === "" || item === "null" || item === undefined
      ).length;
    }

    if (
      countEmpty > 0 ||
      hasEmpty ||
      statusJawaban.length === 0 ||
      statusJawaban.length < DaftarSoal.listSoal.length
    ) {
      setAlertModalOpen(true);
    } else {
      handleOpenModal();
    }
    // let isAllAnswered = statusJawaban.every((item) => item !== "");
    // if (isAllAnswered) {
    //   handleOpenModal();
    // } else {
    //   setAlertModalOpen(true);
    // }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 64);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isPauseModalOpen, setPauseModalOpen] = useState(false);
  const [isStopModalOpen, setStopModalOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isAlertTimeOutOpen, setAlertTimeOutOpen] = useState(false);
  const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const headerRef = useRef();
  
    const handleOpenModal = () => {
      setModalOpen(true);
    };

  const handleOpenModalTimeout = () => {
    if (!isAlertProgresOpen) {
      setAlertTimeOutOpen(true);
      clearAllTimers();
    }
  };

  const handleConfirm = () => {
    clearAllTimers();
    setModalOpen(false);
    setAlertTimeOutOpen(false);
    setAlertProgresOpen(true);
    //set status ujian selesai
    let localStatusSave = localStorage.getItem("statusSave") || "[]";
    if (localStatusSave) {
      localStatusSave = JSON.parse(localStatusSave);
    }

    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }

    let localWaktuMengerjakan =
      localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join("||"),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      statusSave: localStatusSave.join(","),
      jenisSoal: localJenisSoal.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance
      .post(API_URL_SAVE_ANSWER + "/peserta/autosave_jawaban", {
        data: encryptedPayload,
      })
      .then((res) => {
        if (res.status === 200) {
          const payload = {
            id_projek: userData.id_projek,
            id_siswa: userData.id_siswa,
            id_projek_ujian: id_test,
            id_ujian: id_ujian,
            id_naskah: Subtest.id_naskah,
            jawaban: "",
            nopes: userData.nopes,
            kode_akses: userData.kode_akses,
          };

          const encryptedPayload = encrypt_res(
            JSON.stringify(payload),
            SECRET_SESSION
          );

          axiosInstance
            .post(API_URL + "/peserta/selesaites", {
              data: encryptedPayload,
            })
            .then((response) => {
              // alert(JSON.stringify(response.data.data));
              if (parseInt(response.data.data) === 1) {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate("/peserta/confirmtoken");
              } else {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate("/peserta/finish_test");
              }
              localStorage.removeItem("statusJawaban");
              localStorage.removeItem("tampilPertanyaan");
              localStorage.removeItem("tampilJawaban");
              localStorage.removeItem("soalAktif");
              localStorage.removeItem("canBack");
              localStorage.removeItem("waktuMengerjakan");
              localStorage.removeItem("idSoal");
              localStorage.removeItem("countdown");
              localStorage.removeItem("statusSave");
              localStorage.removeItem("jenisSoal");

              if (dataProjek && dataProjek.kamera == 1) {
                let captureImage = headerRef.current.capture();
                if (captureImage){
                  axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
                    id_projek: userData.id_projek,
                    id_siswa: userData.id_siswa,
                    id_ujian: 0,
                    nopes: userData.nopes,
                    image: captureImage,
                    timeStamp: Math.floor(Date.now() / 1000)
                  });
                }
              }
            });
        } else {
          setAlertProgresOpen(false);
          setAlertVisible(true);
        }
      });
  };

  const handleToEmpty = () => {
    //get index of empty value
    let emptyIndex = statusJawaban.findIndex(
      (item) => item === "" || item === null || item === undefined
    );
    setCanBack(true);
    setAlertModalOpen(false);
    handleTabChange(emptyIndex);
    localStorage.setItem("canBack", true);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setAlertModalOpen(false);
  };

  const saveAnswerRedis = () => {

    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localWaktuMengerjakan = localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }
    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      jumlah_soal: DaftarSoal.listSoal.length,
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join(","),
      jenisSoal: localJenisSoal.join(","),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_jawaban_redis", {data: encryptedPayload});
  };

  const [selectedValues, setSelectedValues] = useState({});

  const handleRadioChange = (group) => (event) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: event.target.value,
    }));

    setShowNext(true);

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.value;
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    });

    const waktu_mengerjakan = moment()
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD HH:mm:ss");

    setWaktuMengerjakan((prevWaktuMengerjakan) => {
      let newStatus = [...prevWaktuMengerjakan];
      newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
      localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
      return newStatus;
    });

    setIdSoal((prevIdSoal) => {
      let newStatus = [...prevIdSoal];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
      localStorage.setItem("idSoal", JSON.stringify(newStatus));
      return newStatus;
    });

    setStatusSave((prevStatusSave) => {
      let newStatus = [...prevStatusSave];
      newStatus[parseInt(group.replace("jawaban", ""))] = 0;
      localStorage.setItem("statusSave", JSON.stringify(newStatus));
      return newStatus;
    });
    // alert(event.target.title);

    //kirim jawaban dengan axios async
    // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
    //   id_projek: userData.id_projek,
    //   id_siswa: userData.id_siswa,
    //   id_ujian: id_ujian,
    //   id_soal: event.target.title,
    //   jenis_soal: 1,
    //   jawaban_pilihan: event.target.value,
    //   jawaban_essai: "",
    //   waktu_mengerjakan: waktu_mengerjakan,
    // });

    setTimeout(() => {
      saveAnswerRedis();
    }, 1000);

    if (isAuto) handleNextTab();
  };

  // MCMA
  const [selectedCheckBoxValues, setSelectedCheckBoxValues] = useState({});
  const handleCheckBoxChange = (group, event) => {
    const value = event.target.value;
    setSelectedCheckBoxValues((prevValues) => {
      const newValues = { ...prevValues };
      if (!newValues[group]) {
        newValues[group] = new Set();
      }
      if (newValues[group].has(value + "|1")) {
        newValues[group].delete(value + "|1");
      } else {
        newValues[group].delete(value + "|0");
        newValues[group].add(value + "|1");
      }

      const sortedValues = Array.from(newValues[group]).sort();
      newValues[group] = new Set(sortedValues);

      const waktu_mengerjakan = moment()
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:ss");

      setWaktuMengerjakan((prevWaktuMengerjakan) => {
        let newStatus = [...prevWaktuMengerjakan];
        newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
        localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
        return newStatus;
      });

      setIdSoal((prevIdSoal) => {
        let newStatus = [...prevIdSoal];
        newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
        localStorage.setItem("idSoal", JSON.stringify(newStatus));
        return newStatus;
      });

      setStatusSave((prevStatusSave) => {
        let newStatus = [...prevStatusSave];
        newStatus[parseInt(group.replace("jawaban", ""))] = 0;
        localStorage.setItem("statusSave", JSON.stringify(newStatus));
        return newStatus;
      });

      //kirim jawaban dengan axios async
      // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
      //   id_projek: userData.id_projek,
      //   id_siswa: userData.id_siswa,
      //   id_ujian: id_ujian,
      //   id_soal: event.target.title,
      //   jenis_soal: 2,
      //   jawaban_pilihan: "",
      //   jawaban_essai: Array.from(newValues[group]).join(";"),
      //   waktu_mengerjakan: waktu_mengerjakan,
      // });

      setShowNext(true);

      setStatusJawaban((prevStatusJawaban) => {
        let newStatus = [...prevStatusJawaban];
        newStatus[parseInt(group.replace("jawaban", ""))] = Array.from(
          newValues[group]
        ).join(";");
        localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
        return newStatus;
      });

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);

      return newValues;
    });
  };

  // PG Benar Salah
  const [selected3Values, setSelected3Values] = useState({});
  const handleRadio3Change = (group, count, index) => (event) => {
    setSelected3Values((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: parseInt(event.target.value),
    }));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      const selectedValues = [];
      for (let i = 0; i < count; i++) {
        const radioButtons = document.querySelectorAll(
          'input[name="jawaban-' + index + "-" + i + '"]'
        );

        // alert('input[name="jawaban' + index + "-" + i + '"]');
        // Filter selected radio buttons and extract their values
        selectedValues[i] = Array.from(radioButtons)
          .filter((radio) => radio.checked)
          .reduce((acc, radio) => {
            acc = radio.alt + "|" + radio.value;
            // acc[radio.name] = radio.value; // or acc[radio.id] = radio.value;
            return acc;
          }, "");
      }
      // let newData = Array.from(selectedValues).join(",");
      // alert(newData);
      // alert(selectedValues.join("|"));
      const hasEmpty = selectedValues.some(
        (item) => item === "" || item === null || item === undefined
      );

      if (!hasEmpty) {
        newStatus[index] = selectedValues.join(";");

        const waktu_mengerjakan = moment()
          .tz("Asia/Bangkok")
          .format("YYYY-MM-DD HH:mm:ss");

        setWaktuMengerjakan((prevWaktuMengerjakan) => {
          let newStatus1 = [...prevWaktuMengerjakan];
          newStatus1[index] = waktu_mengerjakan;
          localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus1));
          return newStatus1;
        });

        setIdSoal((prevIdSoal) => {
          let newStatus1 = [...prevIdSoal];
          newStatus1[index] = event.target.title;
          localStorage.setItem("idSoal", JSON.stringify(newStatus1));
          return newStatus1;
        });

        setStatusSave((prevStatusSave) => {
          let newStatus3 = [...prevStatusSave];
          newStatus3[index] = 0;
          localStorage.setItem("statusSave", JSON.stringify(newStatus3));
          return newStatus3;
        });

        //kirim jawaban dengan axios async
        // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
        //   id_projek: userData.id_projek,
        //   id_siswa: userData.id_siswa,
        //   id_ujian: id_ujian,
        //   id_soal: event.target.title,
        //   jenis_soal: 3,
        //   jawaban_pilihan: "",
        //   jawaban_essai: newStatus[index],
        //   waktu_mengerjakan: waktu_mengerjakan,
        // });

        setShowNext(true);

        if (isAuto) handleNextTab();
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] =
        //   selectedValues.join(";");
      } else {
        newStatus[index] = "";
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] = "";
      }

      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);

      return newStatus;
    });
  };

  const handleTextAreaChange = (event, group, maxWords) => {
      const textarea = event.target;
      let value = event.target.value;
  
      // Hitung kata dan terapkan batasan
      const words = value.trim().split(/\s+/).filter(Boolean);
      let wordCount = words.length;
      if (wordCount > 1) {
        setShowNext(true);
      } else {
        setShowNext(false);
      }
  
      // if (wordCount > maxWords) {
      //   value = words.slice(0, maxWords).join(" ");
      //   // Jika Anda ingin memberi tahu pengguna secara langsung (misalnya, dengan alert) bahwa teks telah dipotong,
      //   // Anda bisa menambahkannya di sini. Namun, umpan balik visual di bawah textarea biasanya cukup.
      // }
      
      // Atur tinggi textarea secara dinamis
      textarea.style.height = 'auto'; // Penting: Reset tinggi agar scrollHeight dihitung ulang dengan benar, terutama saat menghapus teks.
      textarea.style.height = `${textarea.scrollHeight}px`; // Set tinggi baru berdasarkan konten.
  
      setSelectedValues((prevSelectedValues) => ({
        ...prevSelectedValues,
        [group]: value,
      }));
  
      setStatusJawaban((prevStatusJawaban) => {
        let newStatus = [...prevStatusJawaban];
        newStatus[parseInt(group.replace("jawaban", ""))] = value;
        localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
        return newStatus;
      });
      const waktu_mengerjakan = moment()
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:ss");
      setWaktuMengerjakan((prevWaktuMengerjakan) => {
        let newStatus = [...prevWaktuMengerjakan];
        newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
        localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
        return newStatus;
      });
      setIdSoal((prevIdSoal) => {
        let newStatus = [...prevIdSoal];
        newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
        localStorage.setItem("idSoal", JSON.stringify(newStatus));
        return newStatus;
      });
      setStatusSave((prevStatusSave) => {
        let newStatus = [...prevStatusSave];
        newStatus[parseInt(group.replace("jawaban", ""))] = 0;
        localStorage.setItem("statusSave", JSON.stringify(newStatus));
        return newStatus;
      });
  
      setTimeout(() => {
        saveAnswerRedis();
      }, 3000);
  
      if (isAuto)
        setTimeout(() => {
          handleNextTab();
        }, 1000);
    };


  const [isAuto, setIsAuto] = useState(false);

  const handleToggle = (isOn) => {
    setIsAuto(isOn);
    // Perform actions based on the toggle state
  };

  const [countdown, setCountdown] = useState(5);
  const [showQuestion, setShowQuestion] = useState(false);
  useEffect(() => {
    if (tampilJawaban) {
      // setTampilJawaban(false);
      setCountdown(0);
      setShowOption(true);
    } else {
      if (countdown > 0) {
        const timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(timer);
      } else {
        setShowQuestion(true);
        if (tampilPertanyaan) {
          setTampilJawaban(false);
          setCountdown2(
            parseInt(DaftarSoal.listSoal[soalAktif].waktu_stimulus)
          );
          // setCountdown2(5);
        }
        // setShowOption(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  const [countdown2, setCountdown2] = useState(0);
  const [showOption, setShowOption] = useState(false);
  useEffect(() => {
    if (countdown2 > 0) {
      const timer2 = setInterval(() => {
        setCountdown2((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(timer2);
    } else {
      setShowQuestion(false);
      localStorage.setItem("tampilPertanyaan", false);
      localStorage.setItem("tampilJawaban", true);
      if (countdown === 0) setShowOption(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown2]);

  // Function to check if webcam is available
  // const isWebcamAvailable = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach((track) => track.stop());
  //     return true;
  //   } catch (err) {
  //     return false;
  //   }
  // };

  //kirim gambar ke server setiap 1 menit jika post.camera !== 0

  // useEffect(() => {
  //   const checkAndCapture = async () => {
  //     if (post && post.camera !== 0 && (await isWebcamAvailable())) {
  //       const interval2 = setInterval(() => {
  //         capture();
  //       }, 60000); // 1 minute interval
  //       intervalRef.current.push(interval2);
  //       return () => clearInterval(interval2);
  //     }
  //   };
  //   checkAndCapture();
  useEffect(() => {
    const checkAndCapture = async () => {
      if (dataProjek && dataProjek.kamera == 1) {
        const interval2 = setInterval(() => {
          let captureImage = headerRef.current.capture();
          if (captureImage){
            axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
              id_projek: userData.id_projek,
              id_siswa: userData.id_siswa,
              id_ujian: 0,
              nopes: userData.nopes,
              image: captureImage,
              timeStamp: Math.floor(Date.now() / 1000)
            });
          }
        }, 60000); // 1 minute interval
        intervalRef.current.push(interval2);
        return () => clearInterval(interval2);
      }
    };
    checkAndCapture();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post]);

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [post]);

  // setelah klik logout pada modal maka logout
  const handleConfirmStop = () => {
    setStopModalOpen(false);
    navigate('/peserta/logout');
  }
  // useEffect for periodic access status check
  // useEffect(() => {
  //     const checkPesanPengawas = async () => {
  //       clearNotificationCheckTimers();

  //       const interval = setInterval(() => {
  //         const payload = {
  //           id_siswa: userData.id_siswa,
  //           id_projek: userData.id_projek
  //         };

  //         // API call to check for new messages
  //         axiosInstance
  //           .post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory", payload)
  //           .then((response) => {
  //             const filtered_response = response.data.data.data.filter(item => item.is_read_by_room_owner == 0);
  //             if (filtered_response.length > 0){
  //               setPesanPengawas(filtered_response[filtered_response.length - 1].text);
  //               let temp_time = new Date(filtered_response[filtered_response.length - 1].created_at);
  //               temp_time.setTime(temp_time.getTime() + 7 * 60 * 60 * 1000);
  //               setTimeStamp(temp_time.toISOString());
                
  //               if (response.status == 200 && response.data.data.data.length > 0){
  //                 // disini implementasi untuk menamilkan messageModal
  //                 setModalMessageOpen(true);
  //               }
  //             }
  //           })
  //           .catch((error) => {
  //             console.error("ada yang salah", error);
  //           });
  //       }, 15000); 

  //       notificationCheckIntervalRef.current.push(interval);

  //       return () => {
  //         clearInterval(interval);
  //       };
  //     };
  //     if (userData.pengawas == 1){
  //       checkPesanPengawas();
  //     }
  //     const checkAccessStatus = async () => {
  //       // Clear any existing intervals to prevent duplicates
  //       clearAccessStatusCheckTimers();
        
  //       const interval = setInterval(() => {
  //         // Prepare payload for status check
  //         const payload = {
  //           id_projek: userData.id_projek,
  //           id_siswa: userData.id_siswa,
  //           nopes: userData.nopes,
  //           password: userData.kode_akses,
  //           id_ujian: id_ujian,
  //         };
          
  //         // Encrypt payload following the app pattern
  //         const encryptedPayload = encrypt_res(
  //           JSON.stringify(payload),
  //           SECRET_SESSION
  //         );
          
  //         // Make API call to check access status
  //         axiosInstance
  //           .post(API_URL + "/peserta/checkAccessStatus", {
  //             data: encryptedPayload,
  //           })
  //           .then((response) => {
  //             // Decrypt the response
  //             const decryptedResponse = response.data.res;
              
  //             // Set the access status
  //             setAccessStatus(decryptedResponse);
              
  //             // Log the response to console
  //             // console.log("Access Status Check Responsse:", decryptedResponse);
              
  //             // Check for status - but not implementing the stopping logic yet
  //             if (decryptedResponse && decryptedResponse.length > 0) {
  //               const statusCheck = decryptedResponse[0];
  //               // console.log(`Access Status ID: ${statusCheck.id_akses_ujian}, Status: ${statusCheck.nama_akses_ujian}, Notes: ${statusCheck.text_catatan}`);
  //               if(statusCheck.id_akses_ujian === 44) {
  //                 // Test is stopped - to be implemented later
  //                 setCatatan(statusCheck['text_catatan']);
  //                 localStorage.setItem("pesan_henti", statusCheck['text_catatan']);
  //                 timerRef.current.pause(); 
  //                 setStarTimer("pause");
  //                 // setStopModalOpen(true);
  //                 timerRef.current.pause(); 
  //                 navigate("/peserta/logout");
  //               } else if (statusCheck.id_akses_ujian === 21){
  //                 setCatatan("Anda sedang request reset login");
  //                 timerRef.current.pause(); 
  //                 setStarTimer("pause");
  //                 setStopModalOpen(true);
  //               }
  //               // Here you would eventually implement the stopping logic
  //               // if (statusCheck.id_akses_ujian === 21) {
  //               //   // Test is stopped - to be implemented later
  //               // }
  //             }
  //           })
  //           .catch((error) => {
  //             console.error("Error checking access status:", error);
  //           });
  //       }, 15000); // Check every 15 seconds - adjust as needed
        
  //       // Store interval reference for cleanup
  //       accessStatusCheckIntervalRef.current.push(interval);
        
        
  //       // Return cleanup function
  //       return () => {
  //         clearInterval(interval);
  //       };
  //     };
      
  //     if (userData.pengawas == 1){
  //       // Execute the check
  //       checkAccessStatus();
  //     }
    
    
  //   // Cleanup on component unmount
  //   return () => {
  //     clearAccessStatusCheckTimers();
  //   };
  // }, [userData.id_projek, userData.id_siswa]); // Depend on userData so it re-runs if user changes

  React.useEffect(() => {
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/get_play_audio", {data: payload}).then((response) => {
      // if (response.data.status === 200) {
        setPlayCounts(response.data.data);
      // } else {
      //   setPlayCounts({});
      // }
    });

  }, []);

  const [playCounts, setPlayCounts] = useState({}); // state lokal (diambil dari Redis awalnya)

  const handlePlay = async (id) => {
    // Update ke backend

    setIsBtnNavigasiEnabled(true);
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      id_soal: id,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_play_audio", {data: payload});
  
    // Update lokal juga (optional untuk re-render langsung)
    setPlayCounts(prev => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  // useEffect(() => {
  //   if (statusJawaban.length > 0) {
  //     if (!isAlertTimeOutOpen) {
  //       const autoSave = async () => {
  //         clearAllTimers();
  //         const interval1 = setInterval(() => {
  //           let localStatusSave = localStorage.getItem("statusSave") || "[]";
  //           if (localStatusSave) {
  //             localStatusSave = JSON.parse(localStatusSave);
  //           }

  //           let localStatusJawaban =
  //             localStorage.getItem("statusJawaban") || "[]";
  //           if (localStatusJawaban) {
  //             localStatusJawaban = JSON.parse(localStatusJawaban);
  //           }

  //           let localWaktuMengerjakan =
  //             localStorage.getItem("waktuMengerjakan") || "[]";
  //           if (localWaktuMengerjakan) {
  //             localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
  //           }

  //           let localIdSoal = localStorage.getItem("idSoal") || "[]";
  //           if (localIdSoal) {
  //             localIdSoal = JSON.parse(localIdSoal);
  //           }

  //           let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
  //           if (localJenisSoal) {
  //             localJenisSoal = JSON.parse(localJenisSoal);
  //           }

  //           const payload = {
  //             id_projek: userData.id_projek,
  //             id_siswa: userData.id_siswa,
  //             id_ujian: parseInt(id_ujian),
  //             soal: localIdSoal.join(","),
  //             statusJawaban: localStatusJawaban.join(","),
  //             waktuMengerjakan: localWaktuMengerjakan.join(","),
  //             statusSave: localStatusSave.join(","),
  //             jenisSoal: localJenisSoal.join(","),
  //             timePost: moment()
  //               .tz("Asia/Bangkok")
  //               .format("YYYY-MM-DD HH:mm:ss"),
  //           };

  //           const encryptedPayload = encrypt_res(
  //             JSON.stringify(payload),
  //             SECRET_SESSION
  //           );

  //           axiosInstance
  //             .post(API_URL_SAVE_ANSWER + "/peserta/autosave_jawaban", {
  //               data: encryptedPayload,
  //             })
  //             .then((response) => {
  //               let newStatusSave = [];
  //               response.data.data.map((item) => {
  //                 // let w1 = moment(item.waktu_mengerjakan);
  //                 // let w2 = moment(localWaktuMengerjakan[item.no_soal]);
  //                 // if (w1.diff(w2, "seconds") >= 0) {
  //                 newStatusSave[item.no_soal] = item.statusCode;
  //                 // } else {
  //                 //   newStatusSave[item.no_soal] = localStatusSave[item.no_soal];
  //                 // }
  //                 return item;
  //               });
  //               setStatusSave(newStatusSave);
  //               localStorage.setItem(
  //                 "statusSave",
  //                 JSON.stringify(newStatusSave)
  //               );

  //               //console.log(response);
  //             });
  //         }, 180000); // 3 minute interval
  //         // }, 10000); // 10 detik interval

  //         const unlisten = navigate((location, action) => {
  //           if (action === "PUSH" || action === "POP") {
  //             clearInterval(interval1);
  //           }
  //         });

  //         intervalRef.current.push(interval1);
  //         return () => {
  //           clearInterval(interval1);
  //           unlisten();
  //         };
  //       };
  //       autoSave();
  //     }
  //   }
  // }, [
  //   isAlertTimeOutOpen,
  //   statusJawaban,
  //   idSoal,
  //   waktuMengerjakan,
  //   statusSave,
  //   id_ujian,
  //   userData.id_projek,
  //   userData.id_siswa,
  //   navigate,
  // ]);

  const handleOpenNavigasiSoal = (status) => {
    setIsVisibleNavigasiSoal(status);
  };

  const [showPrevious] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [canClikTab] = useState(false);

  const fixImagesInParagraphs = (html) => {
    return html.replace(
      /<p([^>]*style\s*=\s*["'][^"']*text-align\s*:\s*(center|justify)[^"']*["'][^>]*)>([\s\S]*?)<\/p>/gi,
      (match, pAttrs, alignType, innerContent) => {
        const updatedContent = innerContent.replace(
          /<img([^>]*?)style="(.*?)"/gi,
          (imgMatch, imgAttrs, imgStyle) => {
            let newStyle = imgStyle;
            if (alignType === 'center' && !imgStyle.includes('display')) {
              newStyle += '; display: block; margin: auto;';
            } else if (alignType === 'justify' && !imgStyle.includes('display')) {
              newStyle += '; display: inline;';
            }
            return `<img${imgAttrs}style="${newStyle}"`;
          }
        );
        return `<p${pAttrs}>${updatedContent}</p>`;
      }
    );
  };

  const scaleSoal = (soal, fontSize) => {

    // Step 1: Tempel ke DOM virtual
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = soal;

    // Step 2: Hitung skala perbandingan font
    const baseFont = 18; // misalnya 14px adalah ukuran asli referensi
    const scale = fontSize / baseFont;

    // Step 3: Apply style font + line height
    const elements = tempDiv.querySelectorAll('*');
    elements.forEach(element => {
      element.style.fontSize = `${fontSize}px`;
      element.style.lineHeight = `${fontSize * 1.5}px`;
      element.style.fontFamily = 'Times New Roman';
    });

    // Step 4: Resize gambar berdasarkan skala
    const images = tempDiv.querySelectorAll('img');
    images.forEach(img => {
      const width = img.getAttribute('width');
      const height = img.getAttribute('height');

      if (width && height) {
        const newWidth = parseFloat(width) * scale;
        const newHeight = parseFloat(height) * scale;
        img.setAttribute('width', newWidth.toFixed(2));
        img.setAttribute('height', newHeight.toFixed(2));
      } else {
        // fallback jika tidak ada width/height, gunakan CSS
        img.style.width = `${img.offsetWidth * scale}px`;
        img.style.height = `${img.offsetHeight * scale}px`;
      }
    });

    //step 4:
    tempDiv.innerHTML = fixImagesInParagraphs(tempDiv.innerHTML);

    return tempDiv.innerHTML;
  };

  if (isLoading) {
    let temp = `/peserta/start_test2?username=${userData.username}&event=${userData.id_projek}`
    return <Loader destination={temp}/>;
  }

  return (
    <div className="App" translate="no">
      <PauseModal
        isOpen={isPauseModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />

      <PauseModal
        isOpen={isStopModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />
      <AlertModal
        isOpen={alertVisible}
        onConfirm={() => setAlertVisible(false)}
        title={"Kesalahan Jaringan"}
        btn_text="Ok."
        subtitle={"Jaringan terganggu. Silakan coba lagi nanti."}
      />

<MessageModal
        isOpen={isMessageModalOpen}
        title="Pesan Pengawas"
        arrayMessages={pesanPengawas}
        subtitle={pesanPengawas}
        // currentMessageIndex={currentMessageIndex}
        // setCurrentMessageIndex={setCurrentMessageIndex}
        // maxIndex={maxIndex}
        // setMaxIndex={setMaxIndex}
        onConfirm={(input) => {
          axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read", 
            {
              id_projek: userData.id_projek,
              id_siswa: userData.id_siswa,
              timestamp: timeStamp
            }
          )
          .then((response) => {
            setModalMessageOpen(false);
          })
          .catch((error) => {
            console.log("Network error pesan jadi tak terbaca");
          });
          // axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/send", 
          //   {
          //     id_projek: userData.id_projek,
          //     id_siswa: userData.id_siswa,
          //     nama_siswa: userData.nama_siswa,
          //     text: input
          //   })
          //   .then((response) => {
          //     // console.log(maxIndex);
          //     input = "";
          //     axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read", 
          //       {
          //         id_projek: userData.id_projek,
          //         id_siswa: userData.id_siswa,
          //         timestamp: timeStamp
          //       }
          //     );
          //   })
          //   .catch((error) => {
          //     console.log("Pesan gagal dikirim");
          //   });
          setModalMessageOpen(false);
        }}
      />

      {alertVisible && (
        <div className="fixed top-0 left-0 right-0 bg-red-500 text-white p-4 text-center">
          <p>Jaringan terganggu. Silakan coba lagi nanti.</p>
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={Subtest && Subtest.urut < Subtest.jumlah_subtest  ? "Jawaban Anda sudah tersimpan. Apakah Anda yakin akan melanjutkan ke subtes berikutnya?" : "Apakah Anda yakin akan menyelesaikan ujian?"
        }
      />

      <AlertModal
        isOpen={isAlertModalOpen}
        onConfirm={handleToEmpty}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Silahkan lengkapi jawaban Anda terlebih dahulu sebelum menyelesaikan subtes."
        }
      />

      <AlertProgres
        isOpen={isAlertProgresOpen}
        title={"Sedang diproses ..."}
        subtitle={""}
      />

      <AlertModal
        isOpen={isAlertTimeOutOpen}
        onConfirm={handleConfirm}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Waktu tes anda sudah habis, silahkan klik tombol untuk menyelesaikan subtes."
        }
      />
      <AlertModal
          isOpen={isStopModalOpen}
          onConfirm={handleConfirmStop}
          title={"Catatan Penghentian Ujian"}
          subtitle={catatanPengawas}
          btn_text="Logout"
        />
      <NoCopyText>
        <div 
          className="App-header"
          // style={{ backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='150' height='50'><text x='0' y='20' font-size='15' fill='gray' fill-opacity='0.3' transform='rotate(-10, 75, 25)'>${userData.nopes}</text></svg>")` }}
          >
          <Header2 app_name={post && post.alamat} camera={dataProjek && dataProjek.kamera != 0} mobile = {isMobile} ref={headerRef}/>
          <div
            className="md:flex flex-row w-full gap-5 lg:px-[100px] sm:px-5"
            style={{
              marginTop: "90px",
              // "margin-top": "10px",
              marginBottom: "100px",
            }}
          >
            <div
              className={
                "login-container w-full  Bg-tutwuri  z-10 bg-white border-2 border-grey-800 rounded-xl shadow-xl p-5"
              }
              style={{
                minHeight: "200px",
              }}
            >
              <div className={!isVisibleNavigasiSoal ? "flex w-full lg:flex-row sm:flex-col flex-wrap gap-1": "flex w-full lg:flex-row sm:flex-col flex-nowrap gap-1"}>
                {/* Kolom Kiri */}
                <div className="flex-grow p-4">
                  <div className="flex justify-between pt-1 pb-3 items-center ">
                      <div className="flex flex-row gap-4 items-center">
                        <div className="mt-1 min-w-[50px] font-bold">
                            Soal Nomor {noSoal && noSoal}
                        </div>
                        <div className="text-sm mt-1 min-w-[120px] text-center flex flex-row gap-2"> {/* Tambahkan gap-2 agar ada jarak antar ikon */}
                          <PiMagnifyingGlassPlus
                            onClick={increaseFontSize}
                            className="text-xl cursor-pointer"  /> 
                          <PiMagnifyingGlassMinus
                            onClick={decreaseFontSize}
                            className="text-xl cursor-pointer" /> 
                        </div>
                      </div>
                      <div className="flex flex-row items-center justify-between gap-2">
                            <PiClock />
                            {Subtest && (
                              <CountdownTimer
                                status={starTimer}
                                ref={timerRef}
                                initialSeconds={Subtest.sisa_waktu}
                                // initialSeconds={3600}
                                onTime={() => handleOpenModalTimeout()}
                              />
                            )}
                      </div>
                    </div>
                  <div className="border-t-4 mb-1 border-gray-200 rounded"></div>

                  <div
                    className="contentSoal border-2 border-gray-200 rounded-md p-4 z-1 custom-height-soal"
                    style={{ minHeight: "400px" }}
                  >
                    {/* <div>{DaftarSoal && JSON.stringify(DaftarSoal.listSoal)}</div> */}
                    {DaftarSoal ? (
                      <div
                        className="flex flex-row flex-wrap"
                        style={
                              { fontSize: `${fontSize}px`, fontFamily: 'Times New Roman' }
                            }
                      >
                        {DaftarSoal.listSoal.map((soal, index) => (
                          <div
                            key={soal.id_soal}
                            label={index + 1}
                            className={
                              activeTabIndex === index ? "w-full" : "hidden"
                            }
                          >
                            <div>
                              {parseInt(soal.waktu_stimulus) > 0 &&
                              countdown > 0 ? (
                                <div className="text-center">
                                  Bersiap Mengingat... <br />
                                  <span className="countdown">
                                    {countdown}
                                  </span>{" "}
                                </div>
                              ) : null}
                              {soal.waktu_stimulus < 1 || showQuestion ? (
                                <div>
                                  <div>{soal.soal && parseHtml(scaleSoal(soal.soal, fontSize))}</div>

                                  {/* Render other parts of the question here */}
                                </div>
                              ) : null}

                              {countdown2 > 0 && !tampilJawaban ? (
                                <div className="absolute top-0 left-[40%] text-center pt-4 ">
                                  <span className="countdown">{countdown2}</span>{" "}
                                </div>
                              ) : null}

                              {soal.multimedia_file && (
                                <AudioQuestion
                                  key={soal.id_soal}
                                  id={soal.id_soal}
                                  playCount={playCounts[soal.id_soal] || 0}
                                  numPlay={post && post.jumlah_play_listening}
                                  question={soal.multimedia_file}
                                  onPlay={handlePlay}
                                  onEndPlay={() => setIsBtnNavigasiEnabled(false)}
                                />
                              
                              )}

                              {soal.waktu_stimulus < 1 || showOption ? (
                                <div>
                                  {soal.pertanyaan && (
                                    <div>
                                      {soal.pertanyaan &&
                                        parseHtml(scaleSoal(soal.pertanyaan, fontSize))}
                                    </div>
                                  )}
                                  {parseInt(soal.jenis_soal) === 1 && (
                                    <div className="grid grid-cols-1 gap-1">
                                      {soal.jumlah_opsi >= 1 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            value="A"
                                            title={soal.id_soal}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "A"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_a &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_a.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 2 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            alt={index}
                                            value="B"
                                            title={soal.id_soal}
                                            id={"jawaban" + index + "-B"}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "B"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_b &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_b.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 3 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            alt={index}
                                            value="C"
                                            title={soal.id_soal}
                                            id={"jawaban" + index + "-C"}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "C"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_c &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_c.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 4 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            alt={index}
                                            value="D"
                                            title={soal.id_soal}
                                            id={"jawaban" + index + "-D"}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "D"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_d &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_d.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 5 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            alt={index}
                                            value="E"
                                            title={soal.id_soal}
                                            id={"jawaban" + index + "-E"}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "E"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_e &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_e.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 6 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <input
                                            type="radio"
                                            className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            alt={index}
                                            value="F"
                                            title={soal.id_soal}
                                            id={"jawaban" + index + "-F"}
                                            checked={
                                              selectedValues["jawaban" + index] ===
                                              "F"
                                            }
                                            onChange={handleRadioChange(
                                              "jawaban" + index
                                            )}
                                          />
                                          <span>
                                            {soal.opsi_f &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_f.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}

                                      {/* <p>Selected Values:</p>
                                <p>
                                  Group {index}: {selectedValues["jawaban" + index]}
                                </p> */}
                                    </div>
                                  )}

                                  {parseInt(soal.jenis_soal) === 2 && (
                                    <div className="grid grid-cols-1 gap-1">
                                      {soal.jumlah_opsi >= 1 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"A"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("A|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_a &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_a.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 2 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"B"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("B|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_b &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_b.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 3 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"C"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("C|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_c &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_c.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 4 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"D"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("D|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_d &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_d.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 5 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"E"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("E|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_e &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_e.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {soal.jumlah_opsi >= 6 && (
                                        <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                          <span>
                                          <input
                                            type="checkbox"
                                            className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                                            name={"jawaban" + index}
                                            id={"jawaban" + index}
                                            alt={index}
                                            value={"F"}
                                            title={soal.id_soal}
                                            checked={
                                              selectedCheckBoxValues[
                                                "jawaban" + index
                                              ]?.has("F|1") || false
                                            }
                                            onChange={(event) =>
                                              handleCheckBoxChange(
                                                "jawaban" + index,
                                                event
                                              )
                                            }
                                          />
                                          </span>
                                          <span>
                                            {soal.opsi_f &&
                                              parseHtml(
                                                scaleSoal(soal.opsi_f.replace(
                                                  /<\?xml[^>]*>|<\/?p>/gm,
                                                  ""
                                                ), fontSize)
                                              )}
                                          </span>
                                        </label>
                                      )}
                                      {/* <p>Selected Values:</p>
                                <p>
                                  Group {index}:{" "}
                                  {selectedCheckBoxValues["jawaban" + index] &&
                                    Array.from(
                                      selectedCheckBoxValues["jawaban" + index]
                                    ).join(";")}
                                </p> */}
                                    </div>
                                  )}

                                  {parseInt(soal.jenis_soal) === 3 && (
                                    <div className="grid grid-cols-1 gap-1">
                                      <table className="min-w-full bg-white border border-gray-300 rounded">
                                        <thead>
                                          <tr className="bg-gray-200 text-gray-700">
                                            <th className="py-2 px-4 border-b w-10">
                                              No.
                                            </th>
                                            <th className="py-2 px-4 border-b text-left">
                                              {scaleSoal(soal.listAnswerText?.[0]?.judul, fontSize) ?? "Pernyataan"}
                                            </th>
                                            {soal.listAnswerText[0].listAnswer.map(
                                              (item, index2) => (
                                                <th
                                                  className="py-2 px-4 border-b text-center w-40"
                                                  key={item.id}
                                                >
                                                  {scaleSoal(item.description, fontSize)}
                                                </th>
                                              )
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {soal.listAnswerText.map(
                                            (item, index2) => (
                                              <tr
                                                key={item.id}
                                                className="hover:bg-gray-100"
                                              >
                                                <td className="py-2 px-4 border text-center">
                                                  {item.group_soal + 1}.
                                                </td>
                                                <td className="py-2 px-4 border">
                                                  {parseHtml(
                                                    scaleSoal(item.text.replace(
                                                      /<[^>]*>?/gm,
                                                      ""
                                                    ), fontSize)
                                                  )}
                                                </td>
                                                {item.listAnswer.map(
                                                  (answer, index3) => (
                                                    <td
                                                      className="py-2 px-4 border text-center"
                                                      key={answer.id}
                                                    >
                                                      <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded px-[50px]">
                                                        <input
                                                          type="radio"
                                                          // name={`soal-${item.id}`}
                                                          // value={answer.id}
                                                          className="form-radio h-5 w-5 checked:border-indigo-500"
                                                          name={
                                                            "jawaban-" +
                                                            index +
                                                            "-" +
                                                            index2
                                                          }
                                                          alt={item.id_butir}
                                                          title={soal.id_soal}
                                                          value={index3}
                                                          // checked={
                                                          //   selected3Values[
                                                          //     "jawaban-" +
                                                          //       index +
                                                          //       "-" +
                                                          //       index2
                                                          //   ] === index3
                                                          // }
                                                          checked={
                                                            selected3Values[
                                                              item.id_butir
                                                            ] === index3
                                                          }
                                                          onChange={handleRadio3Change(
                                                            item.id_butir,
                                                            soal.listAnswerText
                                                              .length,
                                                            index
                                                          )}
                                                        />
                                                        {/* {selected3Values[
                                                "jawaban-" + index + "-" + index2
                                              ] + index3} */}
                                                      </label>
                                                    </td>
                                                  )
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                      {/* <p>Selected Values:</p>
                                <p>
                                  Group {index}: {statusJawaban[index]}
                                </p> */}
                                    </div>
                                  )}

                                  {parseInt(soal.jenis_soal) === 4 && (
                                  <div
                                  // className={
                                  //   soal.tampilan_opsi &&
                                  //   parseInt(soal.tampilan_opsi) === 1
                                  //     ? "flex items-center mt-4" // Ini sepertinya tidak relevan untuk textarea, mungkin sisa copy-paste
                                  //     : "grid grid-cols-1 gap-1"
                                  // }
                                    className={
                                      soal.tampilan_opsi &&
                                      parseInt(soal.tampilan_opsi) === 1
                                        ? "flex items-center mt-4"
                                        : "grid grid-cols-1 gap-1"
                                    }
                                  >
                                    {(() => {
                                      const currentText = selectedValues["jawaban" + index] || '';
                                      const currentWordsArray = currentText.trim().split(/\s+/).filter(Boolean);
                                      const currentWordCount = currentWordsArray.length;
                                      const maxWordsForThisSoal = soal.max_kata || 700; // Ambil dari soal atau default 1000

                                      return (
                                        <>
                                    <textarea
                                      className="lg:max-h-[400px] form-textarea w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500" // Menghapus h-32
                                      name={"jawaban" + index}
                                      id={"jawaban" + index}
                                      value={selectedValues["jawaban" + index] || ''}
                                      onChange={(e) =>
                                        handleTextAreaChange(e, "jawaban" + index, maxWordsForThisSoal)
                                      }
                                      onPaste={(e) => {
                                        e.preventDefault();
                                      }}
                                      rows="10" // Mulai dengan tinggi untuk 1 baris teks
                                      placeholder="Tulis jawaban Anda di sini..."
                                    />
                                          <div className={`text-right mt-1 text-xs ${currentWordCount > maxWordsForThisSoal ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
                                            {currentWordCount}/{maxWordsForThisSoal}
                                            {currentWordCount >= maxWordsForThisSoal && <span className="text-red-600 font-semibold"> (Batas maksimum tercapai)</span>}
                                          </div>
                                        </>
                                      );
                                    })()}
                                  </div>
                                )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <Loading />
                    )}
                  </div>
                  {!isVisible && (
                    <div
                      className={
                        showPrevious
                          ? "flex justify-between pt-5 "
                          : "flex justify-center pt-5"
                      }
                    >
                      {showPrevious && (
                        <button
                          type="button"
                          id="btn-previous"
                          onClick={handlePreviousTab}
                          disabled={activeTabIndex === 0}
                          className="flex items-center bg-red-500 hover:bg-red-800 text-white py-2 px-4 rounded-xl h-10 mt-1"
                        >
                          <FaArrowLeft />
                          <span className="pl-2">Soal Sebelumnya</span>
                        </button>
                      )}
                      {showNext && (
                        <button
                          type="button"
                          id="btn-next"
                          disabled={isBtnNavigasiEnabled}
                          onClick={
                            DaftarSoal &&
                            activeTabIndex === DaftarSoal.listSoal.length - 1
                              ? handleFinishTest
                              : handleNextTab
                          }
                          // disabled={
                          //   DaftarSoal &&
                          //   activeTabIndex === DaftarSoal.listSoal.length - 1
                          // }
                          className="flex items-center hover:bg-blue-800 text-white py-2 px-4 rounded-xl h-10 mt-1 backgroundColor"
                        >
                          <span className="pr-2">
                            {DaftarSoal &&
                            activeTabIndex === DaftarSoal.listSoal.length - 1
                              ? "Selesai"
                              : "Soal Selanjutnya"}
                          </span>
                          {DaftarSoal &&
                          activeTabIndex === DaftarSoal.listSoal.length - 1 ? (
                            ''
                          ) : (
                            <PiCaretRightBold />
                          )}
                        </button>
                      )}
                    </div>
                  )}
                  </div>

                  {/* Kolom Kanan */}
                <div 
                      className={isVisibleNavigasiSoal ? "w-full lg:w-1/6 p-4 md:min-w-[300px]" : "translate-x-full hidden w-full lg:w-1/6 p-4 md:min-w-[300px]"}
                > {/* w-1/4 membuat kolom kanan mengambil 1/4 lebar total */}
                    <div className="border border-muted p-4 rounded-lg flex flex-row items-center backgroundColor gap-4 mb-4 shadow" >
                      <PiCaretLeftBold className="cursor-pointer" onClick={() => handleOpenNavigasiSoal(false)} />
                      <div>
                        {DaftarSoal?.listSoal[noSoal - 1].subtes1 && parseHtml(DaftarSoal.listSoal[noSoal - 1].subtes1)}
                      </div>
                    </div>
                    <div className="border border-muted rounded-lg items-center  mb-4 shadow py-4 px-2 contentSoal custom-height-soal lg:min-h-[395px]">
                      <div className="flex flex-row gap-1 justify-between py-2 px-2 items-center w-full">
                        <div className="text-sm font-bold">DAFTAR SOAL </div>
                        {/* {!isBtnNavigasiEnabled && <Toggle onToggle={handleToggle} />} */}
                        <div className="">
                          <InfoStatusJawab />
                        </div>
                      </div>
                      
                      {DaftarSoal ? (
                        <div className="text-sm">
                          <div className="flex flex-row justify-center flex-wrap">
                            {DaftarSoal.listSoal.map((soal, index) => (
                              <div className="relative inline-block" key={index}>
                                <div className="m-0 rounded-lg">
                                  <button
                                    key={index}
                                    type="button"
                                    onClick={setTab.bind(this, index)}
                                    disabled={isBtnNavigasiEnabled}
                                    className={
                                      activeTabIndex === index
                                        ? "bg-[#01B224] border-1 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1 text-white" // aktif
                                        : statusJawaban[index] ? (
                                          "bg-[#2D7DBE] border border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1 text-white" // sudah dijawab
                                        ) : (
                                          "bg-[#F3F3F3] border border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1 text-[#C9C9C9]" // belum dijawab 
                                        )
                                    }
                                    style={{ width: "40px" }}
                                  >
                                    {index + 1}
                                  </button>
                                  {/* {statusJawaban[index] && (
                                    <span
                                      className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-sm font-medium text-white bg-green-500 rounded-full"
                                      style={{ transform: "translate(10%, -10%)" }}
                                    >
                                      <FaCheck className="w-2" />
                                    </span>
                                  )} */}
                                </div>
                              </div>

                              // <div>
                              //   <button
                              //     key={index}
                              //     type="button"
                              //     onClick={setTab.bind(this, index)}
                              //     className={
                              //       activeTabIndex === index
                              //         ? "bg-blue-500 border-2 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1"
                              //         : "bg-white-500 border-2 border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1"
                              //     }
                              //     style={{ width: "40px" }}
                              //   >
                              //     {index + 1}
                              //   </button>
                              // </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <Loading />
                      )}
                    </div>
                </div>
                {!isVisibleNavigasiSoal && (
                  <div className="absolute top-20 -right-[40px]  rotate-90  p-1 text-sm font-bold bg-green-500 text-white rounded-b-lg shadow cursor-pointer z-10" onClick={() => handleOpenNavigasiSoal(true)}>
                      <div className="flex justify-end items-center gap-2">
                          Daftar Soal <PiGridNine />
                      </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {isVisible && (
            <div className=" fixed bottom-0 w-full left-0 px-5 py-1 z-30 ">
              <div className="login-container w-full mb-2   flex flext-row justify-between items-center w-full  p-4 bg-white rounded-xl shadow-xl ">
                {showPrevious && (
                  <button
                    type="button"
                    id="btn-previous"
                    onClick={handlePreviousTab}
                    disabled={activeTabIndex === 0}
                    className="flex justify-center items-center text-center bg-red-500 hover:bg-blue-800 text-white py-2 px-4 rounded-xl h-10  mt-1 md:min-w-[190px]"
                  >
                    <FaArrowLeft />
                    <span className="pl-2 hidden sm:inline">
                      Soal Sebelumnya
                    </span>
                  </button>
                )}

                {/* <div className="text-sm">Daftar Soal :</div> */}
                {DaftarSoal ? (
                  <div className="text-sm">
                    <div className="flex flex-row justify-center flex-wrap">
                      {(() => {
                        let nomorSoal = 1; // Declare nomorSoal outside the map function
                        return DaftarSoal.listSoal.map((soal, index) => (
                          <div className="relative inline-block" key={soal.id_soal}>
                            <div className="m-0 rounded-lg">
                              <button
                                key={index}
                                type="button"
                                onClick={setTab.bind(this, index)}
                                className={
                                  activeTabIndex === index
                                    ? "bg-blue-500 border-2 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1"
                                    : "bg-white-500 border-2 border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1"
                                }
                                style={
                                  soal.caption_nomor === null
                                    ? { width: "40px" }
                                    : { width: "" }
                                }
                              >
                                {soal.caption_nomor === null ? nomorSoal++ : soal.caption_nomor}
                              </button>
                              {statusJawaban[index] && (
                                <span
                                  className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-sm font-medium text-white bg-blue-500 rounded-full"
                                  style={{ transform: "translate(10%, -10%)" }}
                                >
                                  <FaCheck className="w-2" />
                                </span>
                              )}
                            </div>
                          </div>
                        ));
                      })()}
                    </div>
                  </div>
                ) : (
                  <Loading />
                )}
                {showNext && (
                  <button
                    type="button"
                    id="btn-previous"
                    disabled={isBtnNavigasiEnabled}
                    onClick={
                      DaftarSoal &&
                      activeTabIndex === DaftarSoal.listSoal.length - 1
                        ? handleFinishTest
                        : handleNextTab
                    }
                    // disabled={
                    //   DaftarSoal &&
                    //   activeTabIndex === DaftarSoal.listSoal.length - 1
                    // }
                    className="flex justify-center items-center text-center hover:bg-slate-800 text-white py-2 px-4 rounded-xl h-10  mt-1 md:min-w-[180px] backgroundColor"
                  >
                    <span className="pr-2 hidden sm:inline">
                      {DaftarSoal &&
                      activeTabIndex === DaftarSoal.listSoal.length - 1
                        ? "Selesai Subtes"
                        : "Soal Selanjutnya"}
                    </span>
                    {DaftarSoal &&
                    activeTabIndex === DaftarSoal.listSoal.length - 1 ? (
                      ''
                    ) : (
                      <PiCaretRightBold />
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </NoCopyText>
    </div>
  );
}

export default ProsesTest2;
